export interface DatadogRumConfig {
  applicationId: string;
  clientToken: string;
  site: string;
  service: string;
  env: string;
  version: string;
  sessionSampleRate: number;
  sessionReplaySampleRate: number;
  defaultPrivacyLevel: 'allow';
  trackUserInteractions: boolean;
  trackResources: boolean;
  trackLongTasks: boolean;
  allowedTracingUrls: string[];
}

function buildAllowedTracingUrls(apiUrl: string | undefined): string[] {
  if (!apiUrl) return [];

  try {
    return [new URL(apiUrl).origin];
  } catch {
    return [];
  }
}

// Init is gated on all three of these being present — local dev leaves them
// empty, so RUM sends nothing. `env` must come from VITE_DD_ENV, never
// import.meta.env.MODE (MODE is 'production' for every deployed build).
export function buildDatadogConfig(env: ImportMetaEnv): DatadogRumConfig | null {
  const ddEnv = env.VITE_DD_ENV;
  const applicationId = env.VITE_DD_APPLICATION_ID;
  const clientToken = env.VITE_DD_CLIENT_TOKEN;

  if (!ddEnv || !applicationId || !clientToken) {
    return null;
  }

  return {
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'mp-portal-frontend',
    env: ddEnv,
    version: env.VITE_DD_VERSION || 'local',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'allow',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls: buildAllowedTracingUrls(env.VITE_API_URL),
  };
}

export const datadogConfig = buildDatadogConfig(import.meta.env);
